/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

// i18n-setup.ts

import { createI18n } from 'vue-i18n';
import axios from 'axios';

import type { I18n, I18nOptions, Composer } from 'vue-i18n';
import enUrl from "@locales/en.json?url";
import deUrl from "@locales/de.json?url";
import hrUrl from "@locales/hr.json?url";
import nlUrl from "@locales/nl.json?url";

export const SUPPORT_LOCALES = ['en', 'hr', 'de', 'nl'];

const loadedLanguages: string[] = [];

export function setupI18n(options: I18nOptions = { locale: 'hr' }): I18n {
  const i18n = createI18n(options) as I18n;
  setI18nLanguage(i18n, <string>options.locale);
  return i18n;
}

export function setI18nLanguage(i18n: I18n, lang: string): string {
  ((i18n.global as unknown) as Composer).locale.value = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html')?.setAttribute('locale', lang);
  return lang;
}

const getFileUrl = (locale: string): string => {
  switch(locale) {
    case 'en': return enUrl;
    case 'de': return deUrl;
    case 'hr': return hrUrl;
    case 'nl': return nlUrl;
    default: return hrUrl; // Default to Croatian
  }
}

export async function loadLocaleMessages(i18n: I18n, locale: string) {
  if (loadedLanguages.includes(locale)) {
    return Promise.resolve(setI18nLanguage(i18n, locale));
  }
  // console.log("Load locale messages for " + locale + " locale");
  // load locale messages with dynamic import
  let url = getFileUrl(locale);
  // console.log('url: ', url);
  return fetch(url) //`locales/${locale}.json`)
    .then((res) => res.json())
    .then((json) => {
      loadedLanguages.push(locale);
      i18n.global.setLocaleMessage(locale, json);
      console.log("messages for " + locale + " locale loaded");
      return setI18nLanguage(i18n, locale);
    })
    .catch((e) => {
      console.log(e);
    });
}
